import { DirectLine } from "botframework-directlinejs";
import { useContext, useEffect } from "react"
import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";

export const useSetDirectLineInstance = ({directlineInstance}: {directlineInstance: DirectLine | null }) => {
    const [,druidWebChatDispatch,] = useContext<DruidWebchatContextType>(DruidWebchatContext);

    useEffect(() => {
        if(directlineInstance) {
           druidWebChatDispatch({
                type:'SET_DIRECTLINEINSTANCE',
                payload: directlineInstance
            });
        }
    }, [directlineInstance, druidWebChatDispatch])
}